export default __webpack_public_path__ + "9e961ae9019a773436feaaedc4fabf7c.png";